import { gql } from '@apollo/client';

const DELETE_INCOMINGORDERS_GROUP = gql`
mutation deleteGroup($groupId: Int!) {
  incomingOrders {
    deleteGroup(groupId: $groupId)
  }
}`;

export default DELETE_INCOMINGORDERS_GROUP;